import React from 'react';

import { Container } from './styles';

const ContainerView = ({ children, flexDirection }) => (
  <Container flexDirection={flexDirection}>{children}</Container>
);

export default ContainerView;
